import mirrorCreator from 'mirror-creator'

export const actionTypes = mirrorCreator([
  'SET_MODE',
  'POST_MESSAGE',
  'SET_GUEST_BLOCKED',
], {prefix: 'app/'})
